<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>

<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title><mat-icon matListIcon>badge</mat-icon>Lista Empleados</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

	<div id="container">
		<br>
		<div id="fieldsContainer">
			<mat-accordion class="iconTitle" multi>
				<mat-expansion-panel>
					<mat-expansion-panel-header>
						<mat-panel-title>
							<mat-icon>find_in_page</mat-icon>B&uacute;squeda Avanzada
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div id="container" class="formControl">
						<div class="control">
							<mat-form-field class="imput-full-width">
							<mat-label>Numero Empleado</mat-label>
							<input type="text" matInput name="filterEmployee.ne" [(ngModel)]="filterEmployee.ne">
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Nombre</mat-label>
								<input matInput type="text" name="filterEmployee.n" [(ngModel)]="filterEmployee.n">
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Apellido Paterno</mat-label>
								<input matInput type="text" name="filterEmployee.ps" [(ngModel)]="filterEmployee.ps">
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Apellido Materno</mat-label>
								<input matInput type="text" name="filterEmployee.ms" [(ngModel)]="filterEmployee.ms">
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
							<mat-label>Activo</mat-label>
							<mat-select  name="filterEmployee.ac" [(ngModel)]="filterEmployee.ac">
								<mat-option value="-1">Todos</mat-option>
								<mat-option value="1">Activas</mat-option>
								<mat-option value="0">Inactivas</mat-option>
							</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div id="buttonContainer">
						<button mat-flat-button class="button" (click)="searchBenefitsPaginatorAS()">
							<mat-icon>search</mat-icon>Consultar
						</button>
					</div>
				</mat-expansion-panel>
			</mat-accordion>
		</div>
		<br>
		<div id="tableContainer"> 
			<app-table #employTable  
				(paginatorEvent)="paginatorEvent($event)"
				(editEvent)="editEvent($event)"
				[tableModel]="tableModel">
			</app-table>
		</div>
		<br>
	</div>
	
	</mat-card-content>
	<mat-card-footer class="general-wf-card-footer">
	</mat-card-footer>
</mat-card>